(() => {
  function init(root) {
    if (!root || root.dataset.mlOccasionsReady === '1') return;
    root.dataset.mlOccasionsReady = '1';

    const gridSelector = root.dataset.gridSelector || '#product-grid';
    const chips = Array.from(root.querySelectorAll('[data-ml-occasion]'));
    const status = root.querySelector('[data-ml-occasion-status]');
    let active = 'all';

    function getItems() {
      const grid = document.querySelector(gridSelector);
      if (!grid) return [];
      return Array.from(grid.querySelectorAll(':scope > .grid__item, :scope > li'));
    }

    function itemKeys(item) {
      const raw = (item.getAttribute('data-ml-occasions') || '').toLowerCase();
      return new Set(
        raw
          .split(/[,\s]+/)
          .map((s) => s.trim())
          .filter(Boolean)
      );
    }

    function updateStatus(visible, total) {
      if (!status) return;
      if (active === 'all') {
        status.hidden = true;
        status.textContent = '';
        return;
      }
      status.hidden = false;
      status.textContent =
        visible === 1 ? '1 Duft wird angezeigt' : `${visible} von ${total} Düften`;
    }

    /* Chips ohne einen einzigen Treffer verschwinden.

       Otton am 17.09.2026 zur Prive-Seite: "mach das 'skin scents' bei
       prive dueften weg. gibt ja aktuell keine skin prive duefte. also
       unnoetig." Die Chip-Liste steht fest in der Section, die Produkte
       einer Sammlung bringen aber nur ihre eigenen Anlaesse mit — auf
       Prive fuehrte das zu einem Knopf, der auf "0 von 4 Dueften" endet.

       Statt den Knopf aus dem Template zu nehmen (dann waere er auch
       dort weg, wo es passende Duefte gibt) entscheidet das hier die
       Sammlung selbst: was kein Produkt traegt, wird nicht angeboten.

       Der Rueckzieher am Anfang ist wichtig — steht das Gitter noch
       nicht oder traegt keine Karte Anlaesse, bleibt alles stehen. Ein
       leeres Ergebnis darf nie die ganze Leiste abraeumen. */
    function chipsAufraeumen() {
      const items = getItems();
      if (!items.length) return;

      const vorhanden = new Set();
      items.forEach((item) => itemKeys(item).forEach((k) => vorhanden.add(k)));
      if (!vorhanden.size) return;

      chips.forEach((chip) => {
        const key = chip.dataset.mlOccasion;
        if (!key || key === 'all') return;
        chip.hidden = !vorhanden.has(key);
      });
    }

    function apply() {
      const items = getItems();
      let visible = 0;
      items.forEach((item) => {
        const match = active === 'all' || itemKeys(item).has(active);
        item.classList.toggle('is-ml-occasion-hidden', !match);
        if (match) visible += 1;
      });
      updateStatus(visible, items.length);
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        active = chip.dataset.mlOccasion || 'all';
        chips.forEach((c) => {
          const on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        apply();
      });
    });

    chipsAufraeumen();
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-ml-occasions]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
